// extracted by mini-css-extract-plugin
module.exports = {"grid":"topicsfeed-module--grid--TcEx7","item":"topicsfeed-module--item--1_Wdk"};